import InfoCardLabelContainerComponent from '../InfoCardLabelComponent';
export * from './InfoCardLabelContainerComponent';
export default InfoCardLabelContainerComponent;
